import { MutationTree } from 'vuex';
import { ADD_USER_ROLE_WITH_PERMISSIONS, DEL_USER_ROLE,
  FETCH_PERMISSIONS_FEATURES,
  FETCH_PERMISSIONS_OF_ROLE,
  FETCH_PERMISSIONS_ROLES,
  IUserRolesStatePayload,
  REINIT,
  RESET_PERMISSIONS_OF_ROLE,
  SET_ADDITION,
  SET_EDITION,
  SET_ERROR,
  SET_NOTIFICATION,
  SET_SELECTED,
  UPDATE_NAVIGATION,
  UPDATE_PERMISSIONS_FEATURES_OF_ROLE,
  UPDATE_PERMISSIONS_ROLES_LIST_STATE,
  USER_ROLES_LIST_NAVIGATION,
  UserRolesState } from './types';

const mutations: MutationTree<UserRolesState> = {
  [REINIT](state: UserRolesState) {
    state.roles.userRoles.navigation.start = 0;
    state.addition = false;
    state.editing = false;
  },
  [FETCH_PERMISSIONS_FEATURES](state: UserRolesState, payload) {
    state.featuresPermissions = payload.list;
  },
  [UPDATE_NAVIGATION](state: UserRolesState, payload) {
    state.roles.userRoles.navigation = payload;
  },
  [SET_ERROR](state: UserRolesState, payload) {
    state.error = payload;
  },
  [FETCH_PERMISSIONS_ROLES](state: UserRolesState, payload) {
    state.roles.userRoles.userRolesList = payload.list;
    state.roles.userRoles.navigation.isLastElementsPage = payload.nextResult === undefined;
    if (state.roles.userRoles.total === 0) {
      state.roles.userRoles.total = payload.list.length + (payload.nextResult
        ? payload.nextResult : 0);
    }
  },
  [RESET_PERMISSIONS_OF_ROLE](state: UserRolesState) {
    state.rolePermissions = {
      id: '',
      displayName: '',
      permissions: []
    };
  },
  [USER_ROLES_LIST_NAVIGATION](state: UserRolesState, { direction }) {
    const incrementValues: any = {
      forward: state.roles.userRoles.navigation.elementsPerPage,
      backward: state.roles.userRoles.navigation.elementsPerPage * -1
    };

    state.roles.userRoles.navigation.start += incrementValues[direction];
  },
  [UPDATE_PERMISSIONS_ROLES_LIST_STATE](
    state: UserRolesState,
    stateToUpdate: IUserRolesStatePayload
  ) {
    const {
      view,
      stateKey,
      stateValue
    } = stateToUpdate;

    state.roles.userRolesListComponentsState[stateKey][view] = stateValue;
  },
  [FETCH_PERMISSIONS_OF_ROLE](state: UserRolesState, payload) {
    state.rolePermissions = payload;
  },
  [UPDATE_PERMISSIONS_FEATURES_OF_ROLE](state: UserRolesState, payload) {
    state.roles.userRoles.userRolesList = state.roles.userRoles.userRolesList.map((role: any) => {
      if (role.id === payload.id) {
        const editedrole = {
          id: payload.id,
          displayName: payload.displayName
        };
        return editedrole;
      }
      return role;
    });
  },
  [SET_EDITION](state: UserRolesState, payload) {
    state.editing = payload;
  },
  [ADD_USER_ROLE_WITH_PERMISSIONS](state: UserRolesState) {
    state.roles.userRoles.total += 1;
  },
  [DEL_USER_ROLE](state: UserRolesState) {
    state.roles.userRoles.total -= 1;
  },
  [SET_NOTIFICATION](state: UserRolesState, payload) {
    state.notification = payload;
  },
  [SET_ADDITION](state: UserRolesState, payload) {
    state.addition = payload;
  },
  [SET_SELECTED](state: UserRolesState, payload) {
    state.selected = payload;
  }
};

export default mutations;
